import React from 'react';
import classNames from 'classnames';
import Lottie from 'react-lottie';
import animationData from './animations/animation.json';
import './styles.scss';

const Spinner = props => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
    };
    
    return (
      <div className={classNames({
          'spinner': true,
          'spinner--is-loading': props.isLoading,
          'spinner--fast': props.fast,
      })}>
        <Lottie 
          options={defaultOptions}
          height={200}
          width={240}
        />
      </div>
    );
};

export default Spinner;